import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IpemarkesRoutingModule } from './ipemarkes-routing.module';
import { IpemarksComponent } from './ipemarks/ipemarks.component';
import { IpelandingComponent } from './ipelanding/ipelanding.component';
import { IpelinkesComponent } from './ipelinkes/ipelinkes.component';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { HttpClientModule } from '@angular/common/http';
import { FlatpickrModule } from 'angularx-flatpickr';
import { IpeDialogComponent } from './ipe-dialog/ipe-dialog.component';
import { IpemarksSearchComponent } from './ipemarks-search/ipemarks-search.component';
import { FormsModule } from '@angular/forms';
import { IpeTestCreationComponent } from './ipe-test-creation/ipe-test-creation.component';


@NgModule({
  declarations: [
    IpemarksComponent,
    IpelandingComponent,
    IpelinkesComponent,
    IpeDialogComponent,
    IpemarksSearchComponent,
    IpeTestCreationComponent,
  ],
  imports: [
    CommonModule,
    AcademicFormModule,
    IpemarkesRoutingModule,
    MatTableModule,
    MatSortModule,
    // BrowserAnimationsModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatCardModule,
    HttpClientModule,
    MatPaginatorModule,
    FlatpickrModule.forRoot(),
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class IpemarkesModule { }
